import getContext from '@/utilities/get-context';
import { getBasicUserData } from './gtmEventTracker';

const isDataLayerEnabled = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  
  if (typeof window.dataLayer === 'undefined') {
    // eslint-disable-next-line no-console
    console.warn('No "dataLayer" variable found!');
    return false;
  }

  return true;
};

export const dataLayerTrack = ({ eventName, data = {}, trackOnceUserId = null }) => {
  if (!isDataLayerEnabled()) {
    return;
  }
  if (trackOnceUserId !== null) {
    const key = `gtm_${eventName}`;
    if (sessionStorage.getItem(key) !== trackOnceUserId) {
      sessionStorage.setItem(key, trackOnceUserId);
    } else {
      // Event already fired
      return;
    }
  }

  const params = {
    event: eventName,
    ...getBasicUserData(),
    ...data,
  };
  window.dataLayer.push(params);
};
